import { LaunchDarklyFlags } from './launchDarklyFlags';
import useLaunchDarkly from './useLaunchDarkly';

/**
 * Operational Compliance Hub UX (main sidebar + hub routes) when either flag is on.
 * Admin System Compliance Hub is separate: hub && !builder (see complianceHubSettingsConfiguration).
 */
const useComplianceHubEnabled = (noLoadWait = false): boolean | undefined => {
    const complianceHubEnabled = useLaunchDarkly(LaunchDarklyFlags.ComplianceHub, noLoadWait);
    const complianceBuilderEnabled = useLaunchDarkly(LaunchDarklyFlags.ComplianceBuilder, noLoadWait);

    if (complianceHubEnabled === undefined && complianceBuilderEnabled === undefined) {
        return undefined;
    }

    return !!complianceHubEnabled || !!complianceBuilderEnabled;
};

export default useComplianceHubEnabled;
